import api from '../../../services/api';
import { readPage, readItem, isOk } from '../../../utils/apiResult';

// ADAY HAVUZU — API sözleşmesi (SPEC F2, `v1/ats-candidate-pools`, hepsi AT.Write):
//   GET    v1/ats-candidate-pools                     (name[like], sayfalı)
//   GET    v1/ats-candidate-pools/{id}
//   POST   v1/ats-candidate-pools                     { name, description }
//   PUT    v1/ats-candidate-pools/{id}                { name, description }
//   DELETE v1/ats-candidate-pools/{id}
//   GET    v1/ats-candidate-pools/{id}/members        (fullName/location/currentTitle[like],
//                                                      tagId[in], source[in], experienceYears
//                                                      [gte|lte|between], consentValid[eq])
//   POST   v1/ats-candidate-pools/{id}/members        { candidateIds: [] }
//   DELETE v1/ats-candidate-pools/{id}/members/{memberId}
//   POST   v1/ats-job-postings/{id}/invite            { candidateIds: [], poolId? }
//                                                     → { sent, skipped: [{ candidateId, reason }] }
//   GET    v1/ats-requisitions/{id}/pool-suggestions  → en fazla 25 öneri
//
// Havuzlar YALNIZ AT.Write/admin'e görünür (tüm adayları içerir) — bu dosyadaki
// hiçbir çağrı AT.Read kullanıcısının ekranından yapılmaz.
//
// api.js OKUMALARDA reject ETMEZ → gerçek sinyal `res.data.status` (utils/apiResult).
// Yazmalarda hata interceptor'da toast'lanır; burada yalnız sonucun TÜRÜ döner.

export const POOLS_ROOT = '/v1/ats-candidate-pools';

// Açılır seçiciler (reddet diyaloğu, "Havuza Ekle") için havuz listesi. Kiracıda
// yüzlerce havuz beklenmez; yine de sayfa boyu sınırlı.
export const fetchPoolOptions = async () => {
  const res = await api.get(POOLS_ROOT, { params: { pageSize: 200, pageNumber: 1 } });
  const { ok, items } = readPage(res);
  return { ok, items: items.map((p) => ({ id: p.id, name: p.name })) };
};

export const fetchPool = async (id) => readItem(await api.get(`${POOLS_ROOT}/${id}`));

// Yazma çağrıları: başarı = istisna yok VE gövdede `status !== false`.
const writeOk = (res) => res?.data?.status !== false;

export const addCandidatesToPool = async (poolId, candidateIds) => {
  try {
    const res = await api.post(`${POOLS_ROOT}/${poolId}/members`, { candidateIds });
    return writeOk(res) ? (res?.data?.data ?? {}) : null;
  } catch {
    return null;
  }
};

export const removePoolMember = async (poolId, memberId) => {
  try {
    const res = await api.delete(`${POOLS_ROOT}/${poolId}/members/${memberId}`);
    return writeOk(res);
  } catch {
    return false;
  }
};

// Davet yanıtı `sent` alanını sayı YA DA kimlik dizisi olarak taşıyabilir —
// ikisi de aynı özete indirgenir.
export const normalizeInviteResult = (data) => {
  const d = data || {};
  const sentCount = Array.isArray(d.sent) ? d.sent.length : (Number(d.sent) || 0);
  const skipped = Array.isArray(d.skipped) ? d.skipped : [];
  return { sentCount, skipped };
};

export const inviteToPosting = async (jobPostingId, candidateIds, poolId) => {
  try {
    const body = { candidateIds };
    if (poolId) body.poolId = poolId;
    const res = await api.post(`/v1/ats-job-postings/${jobPostingId}/invite`, body);
    if (!writeOk(res)) return null;
    return normalizeInviteResult(res?.data?.data);
  } catch {
    return null;
  }
};

// Yayındaki ilanlar — davet YALNIZ `published` ilana gider (sunucu kapısı).
// `requisitionId` verilirse o kadronun ilanlarıyla sınırlanır (öneri bileşeni).
export const searchPublishedPostings = async (term, requisitionId) => {
  const params = { 'status[in]': 'published', pageSize: 30 };
  if (term) params['title[like]'] = term;
  if (requisitionId) params['requisitionId[eq]'] = requisitionId;
  const res = await api.get('/v1/ats-job-postings', { params });
  const { items } = readPage(res);
  return items.map((p) => ({ id: p.id, name: p.title }));
};

export const fetchPostingLabel = async (id) => {
  const it = readItem(await api.get(`/v1/ats-job-postings/${id}`));
  return { id, name: it?.title || '' };
};

export const fetchPoolSuggestions = async (requisitionId) => {
  const res = await api.get(`/v1/ats-requisitions/${requisitionId}/pool-suggestions`);
  const ok = isOk(res);
  const d = res?.data?.data;
  const items = Array.isArray(d) ? d : (d?.data || d?.items || []);
  return { ok, items: ok ? items : [] };
};
